import LatestNewsScreen from "@/src/screens/news/latest-news-screen/latest-news-screen";

export default function LatestNews() {
  return <LatestNewsScreen />;
}